// extracted by mini-css-extract-plugin
export default {"pointer":"absenceInProgress_pointer__ZvYxv"};